
import Swal from "sweetalert2";
import escudo from "../Ingresos/escudo";
import logoProvincia from "./logoProvincia";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";
import axios from "axios";

pdfMake.vfs = pdfFonts.vfs;

// ==============================================
// HELPERS
// ==============================================

const formatearValor = (valor) => {
  if (valor === null || valor === undefined || valor === "") return "-";
  if (valor === true || valor === "true") return "Sí";
  if (valor === false || valor === "false") return "No";

  if (Array.isArray(valor)) {
    if (valor.length === 0) return "-";
    return valor.join("\n");
  }

  if (typeof valor === "string" && valor.includes("T00:00:00")) {
    return valor.split("T")[0];
  }

  return String(valor);
};

const parseDireccionTextoPlano = (valor) => {
  if (typeof valor !== "string") return null;

  const match = valor.match(/Mapa:\s*(https?:\/\/\S+)/i);
  if (!match?.[1]) return null;

  return {
    direccion: valor.replace(/Mapa:\s*https?:\/\/\S+/i, "").trim(),
    urlGoogleMaps: match[1].replace(/\s/g, ""),
  };
};

const parseUbicacion = (valor) => {
  try {
    if (!valor) return null;
    if (typeof valor === "object") return valor;

    let limpio = String(valor).trim();

    for (let i = 0; i < 4; i++) {
      if (
        typeof limpio === "string" &&
        limpio.startsWith('"') &&
        limpio.endsWith('"')
      ) {
        limpio = limpio.slice(1, -1);
      }

      limpio = String(limpio).replace(/\\"/g, '"');

      const parsed = JSON.parse(limpio);
      if (parsed && typeof parsed === "object") return parsed;

      limpio = parsed;
    }

    return null;
  } catch {
    return null;
  }
};

const formatearDireccion = (valor) => {
  const direccionTexto = parseDireccionTextoPlano(valor);
  if (direccionTexto) return direccionTexto;

  const ubicacion = parseUbicacion(valor);

  if (ubicacion?.direccion) {
    const lat = ubicacion.latitud || ubicacion.lat || "";
    const lng = ubicacion.longitud || ubicacion.lng || "";

    return {
      direccion: ubicacion.direccion,
      urlGoogleMaps: String(
        ubicacion.maps || `https://www.google.com/maps?q=${lat},${lng}`
      ).replace(/\s/g, ""),
    };
  }

  if (typeof valor === "string" && valor.includes("direccion:")) {
    const limpio = valor.replaceAll("{", "").replaceAll("}", "");

    const direccion = limpio
      .match(/direccion:(.*?)(,latitud:|,lat:)/i)?.[1]
      ?.trim();

    const latitud = limpio.match(/latitud:([^,]+)/i)?.[1]?.trim();
    const longitud = limpio.match(/longitud:([^,]+)/i)?.[1]?.trim();

    const maps = limpio.match(/maps:(https?:\/\/.+)$/i)?.[1]?.trim();

    return {
      direccion: direccion || "-",
      urlGoogleMaps: String(
        maps || `https://www.google.com/maps?q=${latitud},${longitud}`
      ).replace(/\s/g, ""),
    };
  }

  return null;
};

const formatearFechaCorta = (valor) => {
  if (!valor) return "-";

  const limpio = String(valor).split("T")[0];
  const partes = limpio.split("-");

  if (partes.length === 3) {
    return `${partes[2]}/${partes[1]}/${partes[0]}`;
  }

  return limpio;
};

const normalizarResultado = (valor) =>
  String(valor ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toUpperCase()
    .replace(/_/g, " ")
    .replace(/\s+/g, " ");

const htmlToPdfMake = (html) => {
  if (!html) return [{ text: "-" }];

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const nodesToPdf = (node) => {
    const result = [];

    node.childNodes.forEach((child) => {
      if (child.nodeType === 3) {
        const txt = child.textContent || "";
        if (txt.trim()) result.push({ text: txt });
      }

      if (child.nodeType === 1) {
        const tag = child.tagName.toLowerCase();
        const content = nodesToPdf(child);

        switch (tag) {
          case "b":
          case "strong":
            result.push({ text: content, bold: true });
            break;

          case "i":
          case "em":
            result.push({ text: content, italics: true });
            break;

          case "u":
            result.push({ text: content, decoration: "underline" });
            break;

          case "br":
            result.push({ text: "\n" });
            break;

          case "p":
          case "div":
            result.push({
              stack: content.length ? content : [{ text: "" }],
              margin: [0, 2, 0, 2],
            });
            break;

          case "li":
            result.push({
              text: [
                { text: "• " },
                ...(content.length ? content : [{ text: "" }]),
              ],
              margin: [8, 1, 0, 1],
            });
            break;

          case "ul":
          case "ol":
            result.push({
              stack: content.length ? content : [{ text: "" }],
              margin: [0, 2, 0, 2],
            });
            break;

          default:
            result.push({
              stack: content.length ? content : [{ text: "" }],
            });
        }
      }
    });

    return result;
  };

  const salida = nodesToPdf(doc.body);
  return salida.length ? salida : [{ text: "-" }];
};

const tablaFamiliaresPdf = (lista = []) => {
  const familiares = Array.isArray(lista) ? lista : [];

  const normalizarFamiliar = (f) => {
    if (typeof f === "string") {
      const obj = {};

      f.split("|").forEach((parte) => {
        const [k, ...resto] = parte.split(":");
        const clave = String(k || "").trim().toLowerCase();
        const valor = resto.join(":").trim();

        if (clave.includes("relación") || clave.includes("vínculo")) {
          obj.tipo = valor;
        }
        if (clave.includes("nombre")) obj.nombre_y_apellido = valor;
        if (clave.includes("fecha")) obj.fecha_nacimiento = valor;
        if (clave.includes("dni")) obj.DNI = valor;
        if (clave.includes("profesión") || clave.includes("ocupación")) {
          obj.profesion_ocupacion = valor;
        }
        if (clave.includes("nivel")) obj.nivel_instruccion = valor;
      });

      return obj;
    }

    return f || {};
  };

  const body = [
    [
      { text: "Vínculo Familiar", bold: true, alignment: "center" },
      { text: "Apellidos y nombres", bold: true, alignment: "center" },
      { text: "Fecha de nacimiento", bold: true, alignment: "center" },
      { text: "DNI", bold: true, alignment: "center" },
      { text: "Profesión / ocupación", bold: true, alignment: "center" },
      { text: "Nivel de instrucción", bold: true, alignment: "center" },
    ],
  ];

  if (!familiares.length) {
    body.push(
      Array.from({ length: 6 }, () => ({
        text: "-",
        alignment: "center",
      }))
    );
  } else {
    familiares.map(normalizarFamiliar).forEach((f) => {
      body.push([
        { text: formatearValor(f.tipo), alignment: "center" },
        { text: formatearValor(f.nombre_y_apellido), alignment: "center" },
        { text: formatearFechaCorta(f.fecha_nacimiento), alignment: "center" },
        { text: formatearValor(f.DNI), alignment: "center" },
        { text: formatearValor(f.profesion_ocupacion), alignment: "center" },
        { text: formatearValor(f.nivel_instruccion), alignment: "center" },
      ]);
    });
  }

  return {
    table: {
      headerRows: 1,
      widths: ["17%", "23%", "15%", "13%", "17%", "15%"],
      body,
    },
    layout: {
      hLineWidth: () => 0.6,
      vLineWidth: () => 0.6,
      hLineColor: () => "#000",
      vLineColor: () => "#000",
      paddingLeft: () => 3,
      paddingRight: () => 3,
      paddingTop: () => 4,
      paddingBottom: () => 4,
    },
    margin: [0, 4, 0, 8],
    fontSize: 7,
  };
};

const renderValorPDF = (valor) => {
  const direccion = formatearDireccion(valor);

  if (direccion) {
    return {
      stack: [
        { text: direccion.direccion || "-" },
        ...(direccion.urlGoogleMaps
          ? [
              {
                text: "Ver ubicación en Google Maps",
                link: direccion.urlGoogleMaps,
                color: "blue",
                decoration: "underline",
                margin: [0, 4, 0, 0],
              },
            ]
          : []),
      ],
      width: "55%",
    };
  }

  return {
    text: formatearValor(valor),
    width: "55%",
  };
};

const obtenerTipoConfidencial = (impresion) => {
  const valor = (impresion || "").toLowerCase();

  if (valor.includes("medico")) return "Médica";
  if (valor.includes("psicologia")) return "Psicológica";
  if (valor.includes("socioambient")) return "Socioambiental";

  return "Declaración Jurada";
};

const normalizarSeccionesParaImprimir = (data = {}) => {
  const persona = data?.persona || {};
  const respuestas = data?.respuestas || {};

  const seccionesBase =
    data?.secciones ||
    data?.formulario?.Seccions ||
    data?.formulario?.secciones ||
    [];

  return seccionesBase
    .map((sec) => {
      const camposBase = sec.campos || sec.Campos || [];

      const campos = camposBase
        .filter((campo) => campo?.imprimible !== false)
        .sort((a, b) => Number(a.orden || 0) - Number(b.orden || 0))
        .map((campo) => {
          let valor = "";

          if (campo.tipo === "html_static") {
            valor = campo.contenido_html || campo.valor || "";
          } else if (campo.origen === "persona" && campo.campo_db) {
            valor =
              campo.valor ??
              respuestas?.[campo.clave] ??
              respuestas?.[campo.id] ??
              persona?.[campo.campo_db] ??
              "";
          } else {
            valor =
              campo.valor ??
              respuestas?.[campo.clave] ??
              respuestas?.[campo.id] ??
              campo.value ??
              campo.respuesta ??
              "";
          }

          return {
            ...campo,
            valor,
          };
        });

      return {
        id: sec.id,
        nombre: sec.nombre,
        orden: sec.orden,
        campos,
      };
    })
    .filter((sec) => sec.campos.length > 0);
};

// ==============================================
// GENERADOR DE DECLARACIÓN JURADA
// ==============================================

export const generarPDFDeclaracionJurada = async (
  data,
  opciones = {}
) => {
  const {
    descargar = true,
    evaluacionFormulario = false,
    calificacion = null,
    texto_aprobado = "",
    texto_rechazado = "",
  } = opciones;

  const resultadoEvaluacion = normalizarResultado(
    calificacion?.resultado
  );

  // Un formulario de evaluación nunca puede emitirse
  // como documento final sin una calificación válida.
  if (
    evaluacionFormulario &&
    !["APTO", "NO APTO"].includes(resultadoEvaluacion)
  ) {
    await Swal.fire(
      "Formulario sin calificar",
      "Primero debés calificar el formulario como APTO o NO APTO.",
      "warning"
    );
    return;
  }

  // El resultado se guarda como APTO/NO APTO, pero el documento
  // utiliza el texto configurable del ítem cuando está disponible.
  const textoResultadoEvaluacion = resultadoEvaluacion === "APTO"
    ? String(texto_aprobado || calificacion?.texto_aprobado || "").trim() || "APTO"
    : String(texto_rechazado || calificacion?.texto_rechazado || "").trim() || "NO APTO";

  const tipo = obtenerTipoConfidencial(data?.formulario?.impresion);
  const Usuario = ObtieneDatosCookies();

  try {
    Swal.fire({
      title: "Generando Declaración Jurada...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => Swal.showLoading(),
    });

    const escudoImg = escudo();
    const logoSantafe = logoProvincia();

    const contenido = [];

    contenido.push(
      {
        image: logoSantafe,
        width: 140,
        alignment: "right",
        margin: [0, 0, 0, 0],
      },
      {
        image: escudoImg,
        width: 60,
        alignment: "left",
        margin: [0, -45, 0, 0],
      },
      {
        text: `CONFIDENCIAL ${tipo}`,
        alignment: "center",
        bold: true,
        fontSize: 24,
        color: "red",
        margin: [0, -20, 0, 5],
      }
    );

    contenido.push({
      text: "INSTITUTO DE SEGURIDAD PÚBLICA",
      alignment: "center",
      bold: true,
      fontSize: 16,
      margin: [0, 10, 0, 5],
    });

    contenido.push(
      {
        text: `${data?.formulario?.nombre || ""}`,
        alignment: "center",
        fontSize: 12,
        margin: [0, 0, 0, 15],
      },
      {
        text: `${data?.formulario?.descripcion || ""}`,
        alignment: "center",
        fontSize: 12,
        margin: [0, 0, 0, 15],
      }
    );

    const persona = data?.persona || {};

    // ==============================================
    // RESULTADO DE EVALUACIÓN DE SANIDAD
    // ==============================================

    if (evaluacionFormulario) {
      const esApto = resultadoEvaluacion === "APTO";

      contenido.push({
        table: {
          widths: ["*"],
          body: [
            [
              {
                stack: [
                  {
                    text: "RESULTADO DE EVALUACIÓN DE SANIDAD",
                    bold: true,
                    fontSize: 12,
                    alignment: "center",
                    color: "#1f2937",
                    margin: [0, 0, 0, 8],
                  },
                  {
                    text: textoResultadoEvaluacion,
                    bold: true,
                    fontSize: textoResultadoEvaluacion.length > 75 ? 14 : textoResultadoEvaluacion.length > 35 ? 17 : 24,
                    alignment: "center",
                    color: esApto ? "#166534" : "#b91c1c",
                    margin: [0, 4, 0, 8],
                  },
                  ...(calificacion?.observacion
                    ? [
                        {
                          text: `Observación: ${calificacion.observacion}`,
                          fontSize: 10,
                          alignment: "left",
                          margin: [0, 5, 0, 0],
                        },
                      ]
                    : []),
                ],
                fillColor: esApto ? "#f0fdf4" : "#fef2f2",
                margin: [10, 10, 10, 10],
              },
            ],
          ],
        },
        layout: "lightHorizontalLines",
        margin: [0, 10, 0, 20],
      });
    }

    const seccionesParaImprimir = normalizarSeccionesParaImprimir(data);

    // ==============================================
    // SECCIONES Y CAMPOS DEL FORMULARIO
    // ==============================================

    seccionesParaImprimir.forEach((sec) => {
      contenido.push({
        text: sec.nombre,
        style: "seccion",
      });

      sec.campos.forEach((campo) => {
        let valor =
          campo.valor ??
          campo.value ??
          campo.respuesta ??
          campo.datos ??
          campo.items ??
          "";

        const esGrupoFamiliar =
          campo.tipo === "repetible" ||
          campo.modelo === "persona_hijos" ||
          campo.clave === "grupo_familiar" ||
          campo.clave === "grupo_familiar_conviviente";

        if (esGrupoFamiliar) {
          const listaFamiliares =
            Array.isArray(valor) && valor.length
              ? valor
              : data.hijos || [];

          contenido.push({
            text: campo.label,
            bold: true,
            margin: [0, 4, 0, 3],
          });

          contenido.push(tablaFamiliaresPdf(listaFamiliares));
          return;
        }

        const direccion = formatearDireccion(valor);

        if (direccion) {
          contenido.push({
            columns: [
              {
                text: campo.label,
                width: "45%",
                bold: true,
              },
              {
                stack: [
                  { text: direccion.direccion || "-" },
                  ...(direccion.urlGoogleMaps
                    ? [
                        {
                          text: "Ver ubicación en Google Maps",
                          link: direccion.urlGoogleMaps,
                          color: "blue",
                          decoration: "underline",
                          margin: [0, 4, 0, 0],
                        },
                      ]
                    : []),
                ],
                width: "55%",
              },
            ],
            margin: [0, 2, 0, 2],
          });

          return;
        }

        if (typeof valor === "string") {
          valor = valor.replaceAll('"', "");
        }

        if (
          (campo.clave?.includes("fecha") ||
            campo.campo_db?.includes("fecha") ||
            campo.tipo === "date") &&
          valor
        ) {
          valor = formatearFechaCorta(valor);
        }

        const esHTML =
          campo.tipo === "html_static" ||
          (typeof valor === "string" && valor.includes("<"));

        contenido.push({
          columns: [
            {
              text: campo.tipo === "html_static" ? "" : campo.label,
              width: campo.tipo === "html_static" ? "0%" : "45%",
              bold: true,
            },
            esHTML
              ? {
                  stack: htmlToPdfMake(valor),
                  width: campo.tipo === "html_static" ? "100%" : "55%",
                }
              : renderValorPDF(valor),
          ],
          margin: [0, 2, 0, 2],
        });
      });
    });

    // ==============================================
    // DECLARACIÓN JURADA
    // ==============================================

    contenido.push(
      { text: "\n\n" },
      {
        text:
          "Declaro bajo juramento que la información suministrada es completa y verdadera",
        alignment: "center",
        bold: true,
        fontSize: 18,
        color: "red",
      }
    );

    contenido.push(
      { text: "\n\n" },
      {
        text: "______________________________",
        alignment: "center",
      },
      {
        text: "Firma del postulante",
        alignment: "center",
      },
      {
        text: `Aclaracion: ${persona.apellido || ""}, ${persona.nombre || ""}`,
        alignment: "center",
      },
      {
        text: `Fecha: ${
          data?.postulacion?.updatedAt
            ? new Date(data.postulacion.updatedAt).toLocaleDateString("es-AR")
            : new Date().toLocaleDateString("es-AR")
        }`,
        alignment: "center",
      }
    );

    // ==============================================
    // DEFINICIÓN DEL DOCUMENTO
    // ==============================================

    const docDefinition = {
      pageMargins: [40, 40, 40, 60],
      content: contenido,

      footer: {
        stack: [
          {
            text:
              "“AÑO 2026 – Año del 240° Aniversario del Natalicio del Brigadier Gral. Don Estanislao López”",
            alignment: "center",
            fontSize: 9,
            margin: [0, 8, 0, 4],
          },
          {
            text: `Genera: Usuario SIGEDI ${
              Usuario?.identificacion || ""
            } - ${Usuario?.apellido || ""}, ${Usuario?.nombre || ""}`,
            alignment: "left",
            fontSize: 5,
            margin: [40, 0, 40, 0],
          },
        ],
      },

      styles: {
        seccion: {
          fontSize: 12,
          bold: true,
          margin: [0, 10, 0, 5],
          color: "#1f4e79",
        },
      },

      defaultStyle: {
        fontSize: 10,
      },
    };

    // ==============================================
    // GENERACIÓN DEL PDF
    // ==============================================

    const pdfBlob = await new Promise((resolve, reject) => {
      try {
        pdfMake.createPdf(docDefinition).getBlob((blob) => resolve(blob));
      } catch (error) {
        reject(error);
      }
    });

    const file = new File(
      [pdfBlob],
      "declaracion_jurada.pdf",
      { type: "application/pdf" }
    );

    const formData = new FormData();
    formData.append("file", file);

    const nombre = data?.postulacion?.id || "sin_id";
    const apellido = persona.apellido || "sin_apellido";

    Swal.update({
      title: "Enviando a firmar...",
      text: "Espere un momento",
    });

    // ==============================================
    // FIRMA DIGITAL
    // ==============================================

    const nombreFirma = `${nombre} (Usuario Bajo: ${
      Usuario?.identificacion || ""
    } - ${Usuario?.apellido || ""}, ${Usuario?.nombre || ""})`;

    const response = await axios.post(
      `https://wwwp.isepsantafe.net.ar/aplica_firma/uploadfile/${nombreFirma}?apellido=${apellido}, ${nombre}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${process.env.REACT_APP_KEY2}`,
        },
        responseType: "blob",
      }
    );

    const blob = new Blob([response.data], {
      type: "application/pdf",
    });

    // ==============================================
    // ABRIR O DESCARGAR PDF FIRMADO
    // ==============================================

    if (descargar) {
      const url = window.URL.createObjectURL(blob);

      const ventana = window.open(url, "_blank");

      if (!ventana) {
        const enlace = document.createElement("a");
        enlace.href = url;
        enlace.download = `declaracion_jurada_${persona.apellido || "postulante"}.pdf`;

        document.body.appendChild(enlace);
        enlace.click();
        document.body.removeChild(enlace);
      }

      // Mantener disponible el objeto durante más tiempo.
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 60000);
    }

    await Swal.fire({
      icon: "success",
      title: "Listo",
      text: evaluacionFormulario
        ? `Formulario firmado con resultado ${resultadoEvaluacion}`
        : "Declaración jurada creada",
    });

    return blob;
  } catch (err) {
    console.error("Error generando Declaración Jurada:", err);

    await Swal.fire(
      "Error",
      err?.message || "No se pudo generar la Declaración Jurada",
      "error"
    );

    throw err;
  }
};
